import { IonContent, IonModal } from '@ionic/react'
import React, { useContext, useRef } from 'react'
import useModalNavigationAnalytics from './analytics/hooks/useModalNavigationAnalytics'
import { AppContext } from './contexts/AppContext'
import { ModalContext } from './contexts/ModalContext'
import { useModalDynamicHeight } from './hooks/useModalDynamicHeight'
import AllTiersModal from './modals/badges/AllTiers'
import Badges from './modals/badges/Badges'
import TierDetailModal from './modals/badges/TierDetails'
import ContractConfirmationModal from './modals/ContractConfirmationModal'
import CreateContractModal from './modals/createContract/CreateContractModal'
import DHInstructions from './modals/DHInstructions'
import SmartChargingInstuctions from './modals/eNodeInit/electricCar/SmartChargingInstructions'
import InvoiceDetail from './modals/InvoiceDetail'
import ContactConfirmationModal from './pages/contact/contactConfirmation/ContactConfirmationModal'
import GeneralContactModal from './pages/contact/generalContact/GeneralContactModal'
import { ContactSupport } from './pages/contactSupport/ContactSupport'

import TrackerModal from './modals/trackerModal/TrackerModal'
import Onboarding from './onboarding/Onboarding'
import ChargingLocations from './pages/devices/electricCar/chargingLocations/ChargingLocations'
import SmartChargeControllerModal from './pages/devices/electricCar/smartCharging/SmartChargeControllerModal'
import Changelog from './pages/home/components/changeLog/Changelog'
import ContractComparison from './pages/home/components/ContractComparison'
import Invoices from './pages/invoices/Invoices'
import MonthlyReport from './pages/monthlyReports/monthlyreport/MonthlyReport'
import MonthlyReportsList from './pages/monthlyReports/MonthlyReportsList'

const ModalRenderer: React.FC = () => {
	const { modalState, modalStackLength, clearModals } = useContext(ModalContext)
	const { isMobileView } = useContext(AppContext)
	const currentModalState = modalState[modalState.length - 1]
	const activeModal = currentModalState?.activeModal

	const contentRef = useRef<HTMLDivElement>(null)

	useModalNavigationAnalytics(activeModal)

	useModalDynamicHeight({
		contentRef,
		activeModal,
		isMobileView,
		modalStackLength,
	})

	const getBackgroundColor = () => {
		switch (activeModal) {
			case 'hvacDetail':
				return '[--ion-background-color:linear-gradient(to_bottom,_transparent_0,_transparent_5.8rem,_#f5f5f5_5.8rem,_#f5f5f5_100%)] dark:[--ion-background-color:linear-gradient(to_bottom,_transparent_0,_transparent_5.8rem,_#0d2d30_5.8rem,_#0d2d30_100%)] bg-[var(--custom-gradient)]'
			default:
				return '[--ion-background-color:#f5f5f5] dark:[--ion-background-color:#031f22]'
		}
	}

	return (
		<IonModal
			className={`custom-modal-wrapper ${getBackgroundColor()} ${!isMobileView ? '[--border-radius:16px] [--max-width:1400px] [--min-width:400px] [--width:70vw] lg:[--width:60vw] xl:[--width:50vw] 2xl:[--width:40vw]' : ''}`}
			isOpen={modalStackLength > 0}
			onIonModalDidDismiss={clearModals}
		>
			<IonContent scrollEvents>
				<div ref={contentRef} className='h-fit'>
					{activeModal === 'invoices' && <Invoices />}
					{activeModal === 'monthlyReports' && <MonthlyReportsList />}
					{activeModal === 'monthlyReportDetail' && <MonthlyReport />}
					{activeModal === 'invoiceDetail' && <InvoiceDetail />}
					{activeModal === 'onboarding' && <Onboarding />}
					{activeModal === 'dhInstructions' && <DHInstructions />}
					{activeModal === 'contractComparison' && <ContractComparison />}
					{activeModal === 'chargingLocations' && <ChargingLocations />}
					{activeModal === 'smartChargingInstructions' && <SmartChargingInstuctions />}
					{activeModal === 'trackerModal' && <TrackerModal />}
					{activeModal === 'contactSupport' && <ContactSupport />}
					{activeModal === 'createContract' && <CreateContractModal />}
					{activeModal === 'contractConfirmation' && <ContractConfirmationModal />}
					{activeModal === 'changelog' && <Changelog />}
					{activeModal === 'smartChargeController' && <SmartChargeControllerModal />}
					{activeModal === 'contact-general' && <GeneralContactModal />}
					{activeModal === 'contact-confirmation' && <ContactConfirmationModal />}
					{activeModal === 'badges' && <Badges />}
					{activeModal === 'badges-tiers' && <AllTiersModal />}
					{activeModal === 'badges-detail' && <TierDetailModal />}
				</div>
			</IonContent>
		</IonModal>
	)
}

export default ModalRenderer
